import { createAction, props } from "@ngrx/store";
import { CreateTeamTeachers } from "src/app/modules/orgadmin/components/team-teachers/team-teachers-output.model";
import { EditTeamTeachersContext } from "src/app/shared/enums/edit-limits-context";
import { CreateTeamTeachersResponse } from "src/app/shared/interfaces/orgadmin/course-teachers";
import { Guid } from "src/app/shared/types/guid";

export const coursePrefix = "[Edit Team Teachers]";

const editTeamTeachersActions = {
  requestLoad: `${coursePrefix} Load`,
  requestEdit: `${coursePrefix} Edit`,
  requestSuccess: `${coursePrefix} Load success`,
  requestFail: `${coursePrefix} Load fail`,
};

export const editTeamTeachersLoad = createAction(
  editTeamTeachersActions.requestLoad,
);

export const editTeamTeachersSuccess = createAction(
  editTeamTeachersActions.requestSuccess,
);

export const editTeamTeachers = createAction(
  editTeamTeachersActions.requestEdit,
  props<{
    OrganizationId: Guid;
    SubscriptionId: Guid;
    TeamId: Guid;
    payload: Partial<CreateTeamTeachers>;
    notificationMessage?: string;
    context?: EditTeamTeachersContext;
    packageId?: string;
    courseId?: string;
  }>(),
);

export const editTeamTeachersFail = createAction(
  editTeamTeachersActions.requestFail,
  props<{ error: CreateTeamTeachersResponse | null }>(),
);
